<script setup lang="ts">
defineProps<{
  title: string;
  goToPage: () => void;
  isClickable: boolean;
}>();
</script>

<template>
  <button
    class="px-3 py-2 border border-gray-300 rounded cursor-pointer text-sm transition-all duration-200 text-[#333] bg-white hover:bg-[#4ae79e] disabled:hover:bg-white disabled:opacity-50 disabled:cursor-not-allowed"
    :disabled="!isClickable"
    @click="goToPage"
  >
    {{ title }}
  </button>
</template>
